
import 'react-map-gl-geocoder/dist/mapbox-gl-geocoder.css';
import React, { useState, useEffect, useRef, useCallback } from 'react';
import ReactMapGL, { Marker, Popup } from 'react-map-gl';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import axios from 'axios';
import { format } from 'timeago.js';
import './app.css';
import Geocoder from 'react-map-gl-geocoder';
import FileUpload from './components/upload/FileUpload';
import ImageSlider from './components/images/ImageSlider';
import { logoutUser } from './actions/authActions';
import Register from './components/details/Register';
import Login from './components/details/Login';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
toast.configure();



function App(props) {
  const [pins, setPins] = useState([]);
  const [users, setUsers] = useState([]);
  const [currentPlaceId, setCurrentPlaceID] = useState(null);
  const [currentLatitude, setcurrentLatitude] = useState(-26.27076);
  const [currentLongitude, setcurrentLongitude] = useState(28.112268);
  const [newPlace, setNewPlace] = useState(null);
  const [isSharing, setSharing] = useState(false);
  const [isParking, setParking] = useState(false);
  const [isYardSecure, setYardSecure] = useState(false);
  const [isPrivateShower, setPrivateShower] = useState(false);
  const [isKidsAllow, setKidsAllow] = useState(false);
  const [isElec, setElec] = useState(false);
  const [isWater, setWater] = useState(false);
  const [landloard, setLandload] = useState(false);
  const [isPet, setPet] = useState(false);
  const [show, setShow] = useState(true);
  const [isShareShower, setShareShower] = useState(false);
  const [picturesURL, setPictresURL] = useState([]);
  const [mapStatus, setMapStatus] = useState(true);
  const { user } = props.auth;
  // URL of uPloaded pictures

  // URL of uPloaded pictures
  const [viewport, setViewport] = useState({
    width: '100vw',
    height: '100vh',
    latitude: currentLatitude,
    longitude: currentLongitude,
    zoom: 16
  });

 

  const handleShow = () => {
    setShow(true);
  };
  const handleClose = () => {
    setShow(false);
  };

  useEffect(() => {
    const getPins = async () => {
      try {
        const res = await axios.get(
          'https://buyorsellrooms.herokuapp.com/api/pins'
        );
        setPins(res.data);
      } catch (error) {
        console.log(error);
      }
    };
    getPins();
  }, []);

  const mapRef = useRef();

  const handleViewportChange = useCallback(
    newViewport => setViewport({ ...newViewport, zoom: 15 }),
    []
  );
  // if you are happy with Geocoder default settings, you can just use handleViewportChange directly
  const handleGeocoderViewportChange = useCallback(newViewport => {
    const geocoderDefaultOverrides = { transitionDuration: 1000 };

    return handleViewportChange({
      ...newViewport,
      ...geocoderDefaultOverrides,
      width: "100%"
      
    });
  }, []);

  const handleDelete = async id => {
    try {
      await axios.delete(
        `https://buyorsellrooms.herokuapp.com/api/pins/delete/${id}`
      );
      setPins(pins.filter(i => i._id !== id));
      setShow(true);

      toast.success('Room deleted successfully', {
        // Set to 15sec
        position: toast.POSITION.TOP_CENTER,
        autoClose: 10000
      });
    } catch (error) {
      console.log(error);
    }
  };

  const handleMarkerClicked = async (id, username) => {
    setCurrentPlaceID(id);

    try {
      const res = await axios.get(
        `https://buyorsellrooms.herokuapp.com/api/users/${username}`
      );
      setUsers(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  const handleAddClick = e => {
    const [long, lat] = e.lngLat;

    setNewPlace({
      lat,
      long
    });
  };
  const handleLogout = () => {
    props.logoutUser();
  };

  const handleSubmit = async e => {
    e.preventDefault();
    const { rent, deposit } = e.target.elements;
    const newPin = {
      username: user.id,
      sharing: isSharing,
      parking: isParking,
      privateShower: isPrivateShower,
      yard: isYardSecure,
      shower: isShareShower,
      kids: isKidsAllow,
      water: isWater,
      electricity: isElec,
      rent: rent.value,
      deposit: deposit.value,
      landloard: landloard,
      pet: isPet,
      urls: picturesURL,
      lat: newPlace.lat,
      long: newPlace.long
    };

    try {
      const res = await axios.post(
        'https://buyorsellrooms.herokuapp.com/api/pins',
        newPin
      );
      setPins([...pins, res.data]);
      setNewPlace(null);
      toast.success('Room added successfully', {
        // Set to 15sec
        position: toast.POSITION.TOP_CENTER,
        autoClose: 10000
      });
    } catch (error) {
      console.log(error);
    }
  };
 
  return (
    <div className= {show ? 'show-sidebar' : ""}>
      <aside className="sidebar">
        <div className="side-inner"  style={{
          background: "linear-gradient( #7579ff, #b224ef)",
        }}>
        <div
       
       
        id="sidebar"
      >
        {pins.map((p, index) => (
          <div key={index}>
            {p._id === currentPlaceId && (
              <div>
                {/* loop an image array */}
                <ImageSlider urls={p.urls} />
                {/*end of loop of image array */}

                {/* start of room details*/}
                <p
                  className=" font-weight-bold text-uppercase px-3 small pb-2 pt-2 mb-0"
                  style={{ color: "black" }}
                >
                  Room Details 
                  <i
                    onClick={handleClose}
                    style={{
                      paddingLeft: 10,
                      paddingRight: 40,
                    }}
                    className="fa fa-times-circle font-weight-bold  fa-2x pointer"
                    aria-hidden="true"
                  ></i>
                  {props.auth.isAuthenticated && p.username === user.id && (
                    <i
                      style={{
                        paddingTop: 15,
                      }}
                      className="fa fa-trash-o text-danger fa-2x pointer"
                      aria-hidden="true"
                      onClick={() => handleDelete(p._id)}
                    ></i>
                  )}
                </p>
                <ul className="nav flex-column ">
                  {p.parking && (
                    <li className="nav-item pb-0">
                      <div
                        className="pl-3 "
                        style={{
                          background: "#7579ff",
                          color: "white",
                        }}
                      >
                        <i className="fa fa-car mr-3  fa-fw"></i>
                        Parking available
                      </div>
                    </li>
                  )}
                  {p.water && (
                    <li className="nav-item pb-0">
                      <div
                        className="pl-3 "
                        style={{
                          background: "#7579ff",
                          color: "white",
                        }}
                      >
                        <i className="fa fa-tint mr-3  fa-fw"></i>
                        Water included
                      </div>
                    </li>
                  )}
                  {p.electricity && (
                    <li className="nav-item pb-0">
                      <div
                        className="pl-3 "
                        style={{
                          background: "#7579ff",
                          color: "white",
                        }}
                      >
                        <i className="fa fa-plug mr-3 fa-fw"></i>
                        Electricity included
                      </div>
                    </li>
                  )}

                  {p.privateShower && (
                    <li className="nav-item pb-0">
                      <div
                        className="pl-3 "
                        style={{
                          background: "#7579ff",
                          color: "white",
                        }}
                      >
                        <i className="fa fa-bath mr-3 fa-fw"></i>
                        Private Shower/toilet
                      </div>
                    </li>
                  )}

                  {p.shower && (
                    <li className="nav-item pb-0">
                      <div
                        className="pl-3 "
                        style={{
                          background: "#7579ff",
                          color: "white",
                        }}
                      >
                        <i className="fa fa-shower mr-3 fa-fw"></i>
                        Share Shower/toilet
                      </div>
                    </li>
                  )}
                  {p.sharing && (
                    <li className="nav-item pb-0">
                      <div
                        className="pl-3 "
                        style={{
                          background: "#7579ff",
                          color: "white",
                        }}
                      >
                        <i className="fa fa-users mr-3 fa-fw"></i>
                        Share Room/Apartment
                      </div>
                    </li>
                  )}
                  {p.kids && (
                    <li className="nav-item pb-0">
                      <div
                        className="pl-3 "
                        style={{
                          background: "#7579ff",
                          color: "white",
                        }}
                      >
                        <i className="fa fa-child mr-3  fa-fw"></i>
                        Kids friendly/allowed
                      </div>
                    </li>
                  )}

                  {p.yard && (
                    <li className="nav-item pb-0">
                      <div
                        className="pl-3 "
                        style={{
                          background: "#7579ff",
                          color: "white",
                        }}
                      >
                        <i className="fa fa-lock mr-3  fa-fw"></i>
                        Secure yard
                      </div>
                    </li>
                  )}
                  {p.pet && (
                    <li className="nav-item pb-0">
                      <div
                        className="pl-3 "
                        style={{
                          background: "#7579ff",
                          color: "white",
                        }}
                      >
                        <i className="fa fa-paw mr-3  fa-fw"></i>
                        Pet allowed
                      </div>
                    </li>
                  )}

                  <li className="nav-item pb-0">
                    <div
                      className="pl-3 "
                      style={{
                        background: "#7579ff",
                        color: "white",
                      }}
                    >
                      <i className="fa fa-money mr-3  fa-fw"></i>
                      rent - {p.rent}
                    </div>
                  </li>

                  {p.deposit > 0 && (
                    <li className="nav-item pb-0">
                      <div
                        className="pl-3 "
                        style={{
                          background: "#7579ff",
                          color: "white",
                        }}
                      >
                        <i className="fa fa-credit-card mr-3  fa-fw"></i>
                        Deposit - {p.deposit}
                      </div>
                    </li>
                  )}
                </ul>
                {/* End of room details*/}

                {/*Users details */}
                <p
                  className=" text-uppercase px-3 small py-2 mb-0"
                  style={{ color: "black" }}
                >
                  Owner's Details
                </p>
                <ul className="nav flex-column bg-white mb-0">
                  <li className="nav-item pb-0">
                    <div
                      className="pl-3 "
                      style={{
                        background: "#7579ff",
                        color: "white",
                      }}
                    >
                      <i className="fa fa-user mr-3  fa-fw"></i>
                      <b>{users ? <small>{users.name}</small> : "Loading.."}</b>
                    </div>
                  </li>

                  <li className="nav-item pb-0">
                    <div
                      className="pl-3 "
                      style={{
                        background: "#7579ff",
                        color: "white",
                      }}
                    >
                      <i className="fa fa-phone mr-3  fa-fw"></i>
                      {users ? <small>{users.phone}</small> : "Loading.."}
                    </div>
                  </li>

                  <li className="nav-item pb-0">
                    <div
                      className="pl-3 "
                      style={{
                        background: "#7579ff",
                        color: "white",
                      }}
                    >
                      <i className="fa fa-clock-o mr-3  fa-fw"></i>
                      {format(p.createdAt)}
                    </div>
                  </li>
                </ul>

                {/*End details */}
              </div>
            )}
          </div>
        ))}
        {!currentPlaceId && (
          <div>
           
            <i
              onClick={handleClose}
              style={{
                paddingLeft: 10,
                paddingRight: 40,
              }}
              className="fa fa-times-circle text-secondary fa-2x pointer"
              aria-hidden="true"
            ></i>
            <h1>Advert</h1>
          </div>
        )}
      </div>
        </div>
      </aside>

      <div className="site-">
        <ReactMapGL
          width="100%"
          height="100%"
          {...viewport}
          ref={mapRef}
          mapboxApiAccessToken="pk.eyJ1IjoibnR1bmFoIiwiYSI6ImNrcHFyamtwNjA3eGwyb3FrZjZjeGVmMmoifQ.7YCujaGGFQrZMLtd63SXcw"
          onViewportChange={nextViewport => setViewport(nextViewport)}
          mapStyle='mapbox://styles/ntunah/ckpqzx8hx0cok18l3hmprf2ob'
          
          onDblClick={handleAddClick}
          transitionDuration="300"
        >
          {/* start of pins/locations */}
          {pins.map((p, index) => (
            <div key={index}>
              {props.auth.isAuthenticated ? (
                p.username === user.id && (
                  <Marker
                    latitude={p.lat}
                    longitude={p.long}
                    offsetLeft={-10}
                    offsetTop={-45}
                  >
                    <div onClick={() => handleShow()}>
                      <i
                        className="fa fa-map-marker "
                        aria-hidden="true"
                        style={{
                          fontSize: viewport.zoom * 3,
                          color: p._id === currentPlaceId ? 'red' : 'blue',
                          cursor: 'pointer'
                        }}
                        onClick={() => handleMarkerClicked(p._id, p.username)}
                      />
                    </div>
                  </Marker>
                )
              ) : (
                <Marker
                  latitude={p.lat}
                  longitude={p.long}
                  offsetLeft={-10}
                  offsetTop={-45}
                >
                  <div onClick={() => handleShow()}>
                    <i
                      className="fa fa-map-marker "
                      aria-hidden="true"
                      style={{
                        fontSize: viewport.zoom * 3,
                        color: p._id === currentPlaceId ? 'red' : 'slateblue',
                        cursor: 'pointer'
                      }}
                      onClick={() => handleMarkerClicked(p._id, p.username)}
                    />
                  </div>
                </Marker>
              )}
            </div>
          ))}
          {/* ends of pins/location */}

          {/* add new location */}
          {newPlace && props.auth.isAuthenticated && (
            <Popup
              latitude={newPlace.lat}
              longitude={newPlace.long}
              closeButton={true}
              closeOnClick={false}
              onClose={() => setNewPlace(null)}
              anchor="left"
            >
              {' '}
              <div className=" col-md-12 col-lg-12 pb-2 ">
                <form onSubmit={handleSubmit}>
                  <div className="card border-primary rounded-0">
                    <div
                      className="card-header p-1 "
                      style={{
                        paddingBotton: 20
                      }}
                    >
                      <FileUpload
                        setPictresURL={setPictresURL}
                        picturesURL={picturesURL}
                      />
                    </div>

                    <div className="card-body p-3">
                      <div
                        className="list-inline pointer"
                        onClick={() => setParking(!isParking)}
                      >
                        <div className="input-group">
                          <div className="input-group-prepend mr-3">
                            <div className="">
                              <i className="fa fa-car text-info" />
                            </div>
                          </div>
                          <p
                            className={isParking ? 'pl-1 pr-5  bg-info' : ''}
                            style={{
                              color: isParking ? 'white' : 'black',
                              width: '85%'
                            }}
                          >
                            {' '}
                            <small>Parking available</small>
                          </p>
                        </div>
                      </div>

                      <div
                        className="list-inline pointer"
                        onClick={() => setWater(!isWater)}
                      >
                        <div className="input-group ">
                          <div className="input-group-prepend mr-4">
                            <div>
                              <i className="fa fa-tint text-info" />
                            </div>
                          </div>
                          <p
                            className={isWater ? 'pl-1 pr-5 bg-info' : ''}
                            style={{
                              color: isWater ? 'white' : 'black',
                              width: '85%'
                            }}
                          >
                            <small>Water included</small>
                          </p>
                        </div>
                      </div>

                      <div
                        className="list-inline pointer"
                        onClick={() => setElec(!isElec)}
                      >
                        <div className="input-group">
                          <div className="input-group-prepend mr-3">
                            <div>
                              <i className="fa fa-plug text-info" />
                            </div>
                          </div>
                          <p
                            className={isElec ? 'pl-1 pr-5 bg-info' : ''}
                            style={{
                              color: isElec ? 'white' : 'black',
                              width: '85%'
                            }}
                          >
                            <small>Electricity included</small>
                          </p>
                        </div>
                      </div>

                      <div
                        className="list-inline pointer"
                        onClick={() => setPrivateShower(!isPrivateShower)}
                      >
                        <div className="input-group ">
                          <div className="input-group-prepend mr-3">
                            <div>
                              <i className="fa fa-bath text-info" />
                            </div>
                          </div>
                          <p
                            className={
                              isPrivateShower ? 'pl-1 pr-5 bg-info' : ''
                            }
                            style={{
                              color: isPrivateShower ? 'white' : 'black',
                              width: '85%'
                            }}
                          >
                            <small> Private Shower/toilet</small>
                          </p>
                        </div>
                      </div>
                      <div
                        className="list-inline pointer"
                        onClick={() => setShareShower(!isShareShower)}
                      >
                        <div className="input-group ">
                          <div className="input-group-prepend mr-3">
                            <div>
                              <i className="fa fa-shower text-info" />
                            </div>
                          </div>
                          <p
                            className={isShareShower ? 'pl-1 pr-5 bg-info' : ''}
                            style={{
                              color: isShareShower ? 'white' : 'black',
                              width: '85%'
                            }}
                          >
                            <small> Share Shower/toilet</small>
                          </p>
                        </div>
                      </div>
                      <div
                        className="list-inline pointer"
                        onClick={() => setSharing(!isSharing)}
                      >
                        <div className="input-group ">
                          <div className="input-group-prepend mr-3">
                            <div>
                              <i className="fa fa-users text-info" />
                            </div>
                          </div>
                          <p
                            className={isSharing ? 'pl-1 pr-5 bg-info' : ''}
                            style={{
                              color: isSharing ? 'white' : 'black',
                              width: '85%'
                            }}
                          >
                            <small>Share Room/Apartment</small>
                          </p>
                        </div>
                      </div>

                      <div
                        className="list-inline pointer"
                        onClick={() => setKidsAllow(!isKidsAllow)}
                      >
                        <div className="input-group mb-1">
                          <div className="input-group-prepend mr-4">
                            <div>
                              <i className="fa fa-child text-info" />
                            </div>
                          </div>
                          <p
                            className={isKidsAllow ? 'pl-1 pr-5 bg-info' : ''}
                            style={{
                              color: isKidsAllow ? 'white' : 'black',
                              width: '85%'
                            }}
                          >
                            <small>Kids friendly/allowed</small>
                          </p>
                        </div>
                      </div>

                      <div
                        className="list-inline pointer"
                        onClick={() => setYardSecure(!isYardSecure)}
                      >
                        <div className="input-group">
                          <div className="input-group-prepend mr-4">
                            <div>
                              <i className="fa fa-lock text-info" />
                            </div>
                          </div>
                          <p
                            className={isYardSecure ? 'pl-1 pr-5 bg-info' : ''}
                            style={{
                              color: isYardSecure ? 'white' : 'black',
                              width: '85%'
                            }}
                          >
                            <small>Secure yard</small>
                          </p>
                        </div>
                      </div>

                      <div
                        className="list-inline pointer"
                        onClick={() => setPet(!isPet)}
                      >
                        <div className="input-group">
                          <div className="input-group-prepend mr-3">
                            <div>
                              <i className="fa fa-paw text-info" />
                            </div>
                          </div>
                          <p
                            className={isPet ? 'pl-1 pr-5 pr-5 bg-info' : ''}
                            style={{
                              color: isPet ? 'white' : 'black',
                              width: '87%'
                            }}
                          >
                            <small>Pet allowed</small>
                          </p>
                        </div>
                      </div>

                      <div className="list-inline pointer">
                        <div className="input-group mb-2">
                          <div className="input-group-prepend">
                            <div className="input-group-text">
                              <i className="fa fa-money text-info" />
                            </div>
                          </div>
                          <input
                            type="number"
                            className="form-control"
                            id="rent"
                            name="rent"
                            placeholder="Rent"
                            required
                          />
                        </div>
                      </div>

                      <div className="form-group">
                        <div className="input-group mb-2">
                          <div className="input-group-prepend">
                            <div className="input-group-text">
                              <i className="fa fa-credit-card text-info" />
                            </div>
                          </div>
                          <input
                            type="number"
                            className="form-control"
                            id="deposit"
                            name="deposit"
                            placeholder="Deposit"
                            required
                          />
                        </div>
                      </div>

                      <div className="text-center">
                        <input
                          type="submit"
                          value="Add Room"
                          className="btn btn-info btn-block rounded-0 py-2"
                        />
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </Popup>
          )}
          {/*end of add new location */}

          {/** search function */}
          <Geocoder
            mapRef={mapRef}
            onViewportChange={handleGeocoderViewportChange}
            mapboxApiAccessToken="pk.eyJ1IjoibnR1bmFoIiwiYSI6ImNrcHFyamtwNjA3eGwyb3FrZjZjeGVmMmoifQ.7YCujaGGFQrZMLtd63SXcw"
            position="top-left"
            collapsed={true}
           
          />
          {/**End search function */}



          <Register id="exampleModal" />
          <Login id="exampleModal" />
          {props.auth.isAuthenticated && (
            <div className="float-login-button">
              <button
                type="button"
                className="btn btn-danger"
                onClick={handleLogout}
              >
                <i
                  className="fa fa-sign-out"
                  aria-hidden="true"
                  style={{
                    paddingRight: 7
                  }}
                />
                Sign Out
              </button>
            </div>
          )}
        </ReactMapGL>
      </div>
    </div>
  );
}
App.propTypes = {
  auth: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  auth: state.auth
});

export default connect(
  mapStateToProps,
  { logoutUser }
)(withRouter(App));
